function isElementInViewport (el) {

  // Special bonus for those using jQuery
  if (typeof jQuery === 'function' && el instanceof jQuery) {
    el = el[0]
  }

  var rect = el.getBoundingClientRect()

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  )
}

function onVisibilityChange (el, callback) {
  var old_visible
  return function () {
    var visible = isElementInViewport(el)
    if (visible != old_visible) {
      old_visible = visible
      if (typeof callback == 'function') {
        callback()
      }
    }
  }
}

function onMoveHandler (event) {
  this.cursor.style.left = `${event.clientX - 32}px`
  this.cursor.style.top = `${event.clientY - 32}px`
}

function onEnterHandler () {
  this.cursor.classList.add('show')
}

function onLeaveHandler () {
  this.cursor.classList.remove('show')
}

function customCursor () {
  this.cursor = document.querySelector('.gallery-cursor')
  if (!this.cursor) return

  const images = document.querySelectorAll('.product__modal-opener--image')
  images.forEach((image) => image.addEventListener('mousemove', onMoveHandler.bind(this)))
  images.forEach((image) => image.addEventListener('mouseenter', onEnterHandler.bind(this)))
  images.forEach((image) => image.addEventListener('mouseleave', onLeaveHandler.bind(this)))
}

window.addEventListener('DOMContentLoaded', () => {
  // main page slideshow
  // $('.main-page-slideshow').slick({
  //   infinite: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   dots:false,
  //     responsive: [
  //     {
  //       breakpoint: 991,
  //       settings: {
  //         arrows: false,
  //       },
  //     }]
  // })
  // slider with counter

  let sliderContainer = document.querySelector('.with-counter .product-slider')
  $(sliderContainer).slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      }, {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  })
  if ($('.product-slider-counter').length) {
    var handler = onVisibilityChange($('.product-slider-counter'), function () {
      $('.count:not(.active)').each(function (thousands_sep) {
        $(this).addClass('active')
        $(this).prop('Counter', 0).animate({
          Counter: $(this).text(),
        }, {
          duration: 1000,
          easing: 'swing',
          step: function (now) {
            $(this).text(Math.ceil(now))
          },
        })
      })
    })
    $(window).on('DOMContentLoaded load resize scroll', handler)
  }
  //  end slider with counter

  //  most popular slider
  $('.product-slider--wrapper:not(.with-counter) .product-slider').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      }, {
        breakpoint: 450,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  })
  //  end most popular slider
//  article slider
  $('.article-slider__wrapper').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
        },
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],

  })

  // infinity scroll
  $(document).on('click', '#more', function (ev) {
    let url = $(ev.currentTarget).attr('href')
    $.ajax({
      type: 'GET',
      url: url,
      beforeSend: function () {
        $('#ProductGridContainer .collection').addClass('loading')
      },
      success: function (data) {
        var filteredData = $(data).find('#product-grid li')
        var btnMore = $(data).find('#more')
        $('#product-grid').append(filteredData)
        $('#more').replaceWith(btnMore)
        $('#ProductGridContainer .collection').removeClass('loading')

        // filteredData.insertBefore( $("#product-list-foot") );
      },
      dataType: 'html',
    })
    ev.preventDefault()
  })

  //product page
  customCursor()
  setTimeout(function () {
    $('.product-recommendations-wrapper').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      responsive: [
        {
          breakpoint: 9999,
          settings: 'unslick',
        }, {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
          },
        },
      ],
    })

  }, 1500)
  $(".product__info--more-details").click(function(ev) {
    ev.preventDefault();
    $([document.documentElement, document.body]).animate({
      scrollTop: $("#product_bottom").offset().top
    }, 500);
  });
  $(".condition-popup").on('click', function() {
    $(`.custom-model-main[data-type="condition"]`).addClass('model-open');
  });
  $(".size-popup").on('click', function() {
    $(`.custom-model-main[data-type="size-guide"]`).addClass('model-open');
  });
  $(".close-btn, .bg-overlay").click(function(){
    $(".custom-model-main").removeClass('model-open');
  });
  lightGallery(document.getElementById('product-gallery'), {
    selector: 'li',
    thumbnail: true,
    hideControlOnEnd: false,
    controls:true,
    plugins: [lgVideo],
    videojs: true,

  });
  if (window.innerWidth < 767) {
    $('product-gallery ul').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: false,
      dots: true,
    })

  } else {
    $('product-gallery ul').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows:false,
      asNavFor: 'thumbnail-slider ul',
      infinite:false
    })
    $('thumbnail-slider ul').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      vertical: true,
      arrows:false,
      asNavFor: 'product-gallery ul',
      verticalSwiping: true,
      focusOnSelect: true,
      dots: true,
      infinite:false
    })
  }

  //sell to us
  $('.category-list__wrapper').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
       {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],

  })

  // about us
  $('.black-slider--wrapper').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  })

  $('.read-more-btn').click(function (ev){
    $(this).parent().find('.read-more-content').toggleClass('active')
    if ($(this).text() == "Read more")
      $(this).text("Read less")
    else
      $(this).text("Read more");
  })
  const content = document.querySelector('.read-more-content.collection-hero__description');
  if (content && window.innerWidth < 769){
    const button = document.querySelector('.read-more-btn');
    const scrollHeight = content.scrollHeight;
    if (scrollHeight > content.offsetHeight  ){
      button.style.display = 'block'
    }
  }

  //customisation
  lightGallery(document.getElementById('portfolio'), {
    selector: 'li',
    thumbnail: true,
    hideControlOnEnd: false,
    controls:true,
    plugins: [lgVideo],
    videojs: true,

  });

  if($('#ui-tabs').length){
    $('.bordered-column-slider__wrapper').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      responsive: [
        {
          breakpoint: 9999,
          settings: 'unslick',
        }, {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
          },
        }, {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
          },
        },
      ],
    })
  }


  // article page
  $('.related_articles').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick',
      }, {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  })


  //press page
  if ( $('#press-wrapper').length){
    $('[data-frames]').magnificPopup({
      type: 'iframe'
    });
    $('[data-gallery]').each((index,elem)=>{

      $(`[data-gallery="${$(elem).attr('data-gallery')}"]`).magnificPopup({
        type: 'image',
        gallery:{
          enabled:true
        }
      });

    })
  }

//  live shop
  $('.events-slider__wrapper').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [{
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  })

  // mobile search
  $('.search--mobile').click(function (ev){
    ev.preventDefault();
    $('.mobile-search').toggleClass('active')
  })
  $('.close-mobile-search').click(function (ev){
    ev.preventDefault();
    $('.mobile-search').removeClass('active')
  })
    
      const slider = document.querySelector('.related-collection--wrapper');
  if(slider){

        let isDown = false;
    let startX;
    let scrollLeft;
    
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;
      console.log(walk);
    });
  }

})
